import { correspondenceConstant } from "../_constants/correspondance.constant"
import { correspondanceService } from "../_services/correspondance.service"
import { alert } from "../_utilities/alert";

export const correspondanceAction = {
    getCorrespondance,
    createCorrespondance,
    deleteCorrespondance,
    updateCorrespondance
}

function getCorrespondance(id) {
    return (dispatch) => {
        dispatch(
            dispatchFunction({
                type: correspondenceConstant.GET_CORRESPONDENCE_DETAIL_REQUEST,
                data: null
            })
        )
        correspondanceService
            .getCorrespondanceDetails(id)
            .then(
                (response) => {
                    if (response.Status === 200) {
                        dispatch(
                            dispatchFunction({
                                type: correspondenceConstant.GET_CORRESPONDENCE_DETAIL_SUCCESS,
                                data: response.Result,
                            })
                        );
                    } else {
                        dispatch(
                            dispatchFunction({
                                type: correspondenceConstant.GET_CORRESPONDENCE_DETAIL_FAILURE,
                                data: null,
                            })
                        );
                    }
                },
                (error) => {
                    dispatch(
                        dispatchFunction({
                            type: correspondenceConstant.GET_CORRESPONDENCE_DETAIL_FAILURE,
                            data: error,
                        })
                    );
                }
            )
            .catch((error) => {
                alert.error("Oops! Something went wrong!!");
            });
    }
}

function createCorrespondance(data) {
    return (dispatch) => {
        dispatch(
            dispatchFunction({
                type: correspondenceConstant.CREATE_CORRESPONDENCE_DETAIL_REQUEST,
                data: null
            })
        );
        correspondanceService
            .createCorrespondanceDetail(data)
            .then(
                (response) => {
                    if (response.Status === 201) {
                        dispatch(
                            dispatchFunction({
                                type: correspondenceConstant.CREATE_CORRESPONDENCE_DETAIL_SUCCESS,
                                data: response.Result,
                            })
                        );
                        alert.success(response.Message)
                    } else {
                        dispatch(
                            dispatchFunction({
                                type: correspondenceConstant.CREATE_CORRESPONDENCE_DETAIL_FAILURE,
                                data: null
                            })
                        )
                        alert.error(response.Message)
                    }
                },
                (error) => {
                    dispatch(
                        dispatchFunction({
                            type: correspondenceConstant.CREATE_CORRESPONDENCE_DETAIL_FAILURE,
                            data: error
                        })
                    )
                }
            ).catch((error) => {
                alert.error("Oops! Something went wrong!!");
            })
    }
}

function deleteCorrespondance(id) {
    return (dispatch) => {
        dispatch(
            dispatchFunction({
                type: correspondenceConstant.DELETE_CORRESPONDENCE_DETAIL_REQUEST,
                data: null
            })
        )
        // correspondanceService
        return correspondanceService

            .deleteCorrespondanceDetail(id)
            .then(
                (response) => {
                    if (response.Status === 200) {
                        dispatch(
                            dispatchFunction({
                                type: correspondenceConstant.DELETE_CORRESPONDENCE_DETAIL_SUCCESS,
                                data: response.Result,
                            })
                        );
                        alert.success(response.Message)
                    } else {
                        dispatch(
                            dispatchFunction({
                                type: correspondenceConstant.DELETE_CORRESPONDENCE_DETAIL_FAILURE,
                                data: null,
                            })
                        );
                        alert.error(response.Message)
                    }
                },
                (error) => {
                    dispatch(
                        dispatchFunction({
                            type: correspondenceConstant.DELETE_CORRESPONDENCE_DETAIL_FAILURE,
                            data: error,
                        })
                    );
                }
            )
            .catch((error) => {
                alert.error("Oops! Something went wrong!!");
            });
    }
}


function updateCorrespondance(formData, id) {
    return (dispatch) => {
        dispatch({
            type: correspondenceConstant.UPDATE_CORRESPONDENCE_DETAIL_REQUEST,
            data: null
        });

        correspondanceService
            .updateCorrespondanceDetail({ ...formData, id })
            .then((response) => {
                if (response.Status === 200) {
                    dispatch({
                        type: correspondenceConstant.UPDATE_CORRESPONDENCE_DETAIL_SUCCESS,
                        data: response.Result
                    });
                    alert.success(response.Message);
                } else {
                    dispatch({
                        type: correspondenceConstant.UPDATE_CORRESPONDENCE_DETAIL_FAILURE,
                        data: null
                    });
                    alert.error(response.Message);
                }
            })
            .catch((error) => {
                dispatch({
                    type: correspondenceConstant.UPDATE_CORRESPONDENCE_DETAIL_FAILURE,
                    data: error
                });
                alert.error("Oops! Something went wrong!!");
            });
    };
}



function dispatchFunction(data) {
    return {
        type: data.type,
        data: data.data
    }
}